module.exports = __webpack_public_path__ + "img/tongc.4f161274.png";